const bahijSemiBold = '/fonts/BahijTheSansArabic-SemiBold.ttf';
const bahijBold = '/fonts/BahijTheSansArabic-Bold.ttf';
const ARABIC_FONT_FAMILY = '"Bahij TheSansArabic", sans-serif';

let fontsReadyPromise = null;

export const ensureArabicFontLoaded = () => {
  if (!fontsReadyPromise) {
    const faces = [
      new FontFace('Bahij TheSansArabic', `url(${bahijSemiBold})`, { weight: '600' }),
      new FontFace('Bahij TheSansArabic', `url(${bahijBold})`, { weight: '700' }),
    ];
    fontsReadyPromise = Promise.all(faces.map((f) => f.load())).then((loaded) => {
      loaded.forEach((f) => document.fonts.add(f));
    }).catch((err) => {
      fontsReadyPromise = null;
      throw err;
    });
  }
  return fontsReadyPromise;
};

const wrapText = (ctx, text, widthAt, startY, lineHeight) => {
  const words = text.split(' ');
  const lines = [];
  let current = '';
  const limit = () => widthAt(startY + lines.length * lineHeight);
  words.forEach((word) => {
    const test = current ? `${current} ${word}` : word;
    if (ctx.measureText(test).width > limit() && current) {
      lines.push(current);
      current = word;
    } else {
      current = test;
    }
  });
  if (current) lines.push(current);
  return lines;
};

export const renderArabicBlockToDataUrl = (
  blocks,
  {
    maxWidthPx = 600,
    maxHeightPx = Infinity,
    scale = 3,
    lineHeightRatio = 1.5,
    floatWidthPx = 0,
    floatHeightPx = 0,
  } = {},
) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const widthAt = (y) => (y < floatHeightPx ? maxWidthPx - floatWidthPx : maxWidthPx);

  let y = 0;
  let full = false;
  const laidOut = [];

  blocks
    .filter((b) => b.text && b.text.trim())
    .forEach((b) => {
      if (full) return;
      ctx.font = `${b.fontWeight || 600} ${b.fontSize}px ${ARABIC_FONT_FAMILY}`;
      const lineHeight = b.fontSize * lineHeightRatio;
      const top = y + (b.marginTop || 0);
      const lines = wrapText(ctx, b.text, widthAt, top, lineHeight);
      const fitting = Math.max(0, Math.floor((maxHeightPx - top) / lineHeight + 1e-6));
      const kept = lines.slice(0, fitting);
      if (kept.length < lines.length) full = true; 
      if (kept.length) {
        laidOut.push({ ...b, lines: kept, lineHeight, top });
        y = top + kept.length * lineHeight;
      }
    });

  const widthPx = maxWidthPx;
  const heightPx = Math.max(y, 1);

  canvas.width = widthPx * scale;
  canvas.height = heightPx * scale;
  ctx.scale(scale, scale);
  ctx.direction = 'rtl';
  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';

  laidOut.forEach((b) => {
    ctx.font = `${b.fontWeight || 600} ${b.fontSize}px ${ARABIC_FONT_FAMILY}`;
    const lead = (b.lineHeight - b.fontSize) / 2; 
    b.lines.forEach((line, i) => {
      ctx.fillText(line, widthPx, b.top + i * b.lineHeight + lead);
    });
  });

  return { url: canvas.toDataURL('image/png'), widthPx, heightPx };
};